import { render, staticRenderFns } from "./issue_milestone.vue.js?vue&type=template&id=e1ac9e88!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=template&id=e1ac9e88"
import script from "./issue_milestone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=script&lang=js"
export * from "./issue_milestone.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e1ac9e88')) {
      api.createRecord('e1ac9e88', component.options)
    } else {
      api.reload('e1ac9e88', component.options)
    }
    module.hot.accept("./issue_milestone.vue.js?vue&type=template&id=e1ac9e88!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./issue_milestone.vue?vue&type=template&id=e1ac9e88", function () {
      api.rerender('e1ac9e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "issuable/components/issue_milestone.vue"
export default component.exports